import { Alert, Button, Stack, Typography } from '@mui/material';

/** Review remains in the staff form, which owns submission checks and verify/discard mutations. */
export function AdminIntakeVerification({
  providers,
  selectedUserId,
  onReview,
}: {
  providers: { id: string; label: string }[];
  selectedUserId: string;
  onReview: (userId: string) => void;
}) {
  const visible = selectedUserId ? providers.filter(item => item.id === selectedUserId) : providers;
  return (
    <Stack spacing={2}>
      <Typography variant="h5">JotPsych verification</Typography>
      <Typography color="text.secondary">
        Review each provider’s submitted intake. Confirm or discard verification from their intake
        review; verification is recorded separately for each provider.
      </Typography>
      {visible.length === 0 ? (
        <Alert severity="info">No practice members are available to review.</Alert>
      ) : (
        visible.map(provider => (
          <Stack key={provider.id} direction="row" sx={{ alignItems: 'center', gap: 2 }}>
            <Typography sx={{ flex: 1 }}>{provider.label}</Typography>
            <Button variant="outlined" onClick={() => onReview(provider.id)}>
              Review intake for {provider.label}
            </Button>
          </Stack>
        ))
      )}
    </Stack>
  );
}
